import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { change } from 'redux-form'
import { PriceDaily } from '../PriceDaily'
import { PriceMonthly } from '../PriceMonthly'
import config from 'SRC/config/config.yaml'

class Container extends React.Component {
  constructor (props) {
    super(props)

    this.rentTypes = config.adForm.rentTypes

    let rentType = this.rentTypes.dailyMonthly.code

    const adPriceDaily = props.adPriceDaily
    const adPriceMonthly = props.adPriceMonthly

    if (adPriceDaily) {
      rentType = this.rentTypes.daily.code
    }

    if (adPriceMonthly) {
      rentType = this.rentTypes.monthly.code
    }

    if (adPriceDaily && adPriceMonthly) rentType = this.rentTypes.dailyMonthly.code

    this.state = {
      rentType,
      showDailyPrice: rentType === this.rentTypes.dailyMonthly.code || rentType === this.rentTypes.daily.code,
      showMonthlyPrice: rentType === this.rentTypes.dailyMonthly.code || rentType === this.rentTypes.monthly.code
    }
  }

  onRentTypeChange = async e => {
    const { change, formName } = this.props
    const rentType = e.target.value

    let showDailyPrice = this.state.showDailyPrice
    let showMonthlyPrice = this.state.showMonthlyPrice

    switch (rentType) {
      case this.rentTypes.dailyMonthly.code:
        showDailyPrice = true
        showMonthlyPrice = true
        break
      case this.rentTypes.daily.code:
        showDailyPrice = true
        showMonthlyPrice = false
        await change(formName, 'priceMonthly', null)
        await change(formName, 'priceMonthlyUnmasked', null)
        break
      case this.rentTypes.monthly.code:
        showDailyPrice = false
        showMonthlyPrice = true
        await change(formName, 'priceDaily', null)
        await change(formName, 'priceDailyUnmasked', null)
        break
      default: break
    }

    this.setState({
      showDailyPrice,
      showMonthlyPrice
    })
  }

  renderRentType = () => {
    const { rentType } = this.state
    return <div className='form-group'>
      <label>Period plaćanja</label>
      <select defaultValue={rentType} onChange={this.onRentTypeChange}>
        {Object.keys(this.rentTypes).map(rentType =>
          <option key={rentType} value={rentType}>
            {this.rentTypes[rentType].title}
          </option>
        )}
      </select>
    </div>
  }

  render () {
    const { formName } = this.props
    const { showDailyPrice, showMonthlyPrice } = this.state

    return <React.Fragment>
      {this.renderRentType()}
      {showDailyPrice ? <PriceDaily formName={formName} /> : null}
      {showMonthlyPrice ? <PriceMonthly formName={formName} /> : null}
    </React.Fragment>
  }
}

Container.displayName = 'Rent'

Container.propTypes = {
  formName: PropTypes.any.isRequired,
  change: PropTypes.func.isRequired,
  adPriceDaily: PropTypes.number,
  adPriceMonthly: PropTypes.number
}

export default connect(null, { change })(Container)
